<template>
    <div v-if="notificacoes && notificacoes.length > 0" id="notificacoes-component">
        <div v-for="(item, index) in notificacoes" :key="index">
            <div class="notificacoes-conteudo text-break mb-2 me-2">
                <div class="notificacoes-conteudo-barra-laranja"></div>
                <div class="ms-3"> {{ item.detalhe }}</div>
            </div>
        </div>
        <div class="notificacoes-espacamento-rodape"></div>
    </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';
// import NotificacoesService from "@/services/notificacoes.service";
import NotificacoesPendentes from "@/services/model/notificacoes-pendentes";
import { useSidebarStore } from '@/stores/sidebar';

export default defineComponent({
    components: {

    },
    props: {
        estilizarSidebarHolder: {
            type: Boolean,
            default: false,
        }
    },
    setup(props) {
        const notificacoes = ref<NotificacoesPendentes[] | null>(null)
        const SidebarStore = useSidebarStore()

        onMounted(() => {
            inicializarComponente(props.estilizarSidebarHolder)
            // notificacoes.value = carregarNotificacoes()
            notificacoes.value = carregarNotificacoesFake() ?? []
            SidebarStore.titulo = 'Notificações'
        })

        const inicializarComponente = (estilizarSidebarHolder: boolean) => {
            if (estilizarSidebarHolder) {
                const sidebarHolder = document.querySelector('.sidebar-holder') as HTMLElement
                sidebarHolder.style.backgroundColor = '#eeeeee'
            }
        }

        // const carregarNotificacoes = async (): NotificacoesPendentes[] => {
        //     try {
        //         const response = await NotificacoesService.obterNotificacoesPendentes()

        //         if (response && response.status === 200) {
        //             return response.data as NotificacoesPendentes[]
        //         }

        //         return null
        //     } catch (error) { window.console.log(error); }
        // }

        const carregarNotificacoesFake = (): NotificacoesPendentes[] => {
            const notificacoes: NotificacoesPendentes[] = []

            for (let index = 0; index < 30; index++) {
                let element = new NotificacoesPendentes()
                element.detalhe = `[${index}] - Ao clicar vai para o local referido da notificação. Ao clicar vai para o local referido da notificação. Ao clicar vai para o local referido da notificação. Ao clicar vai para o local referido da notificação. Ao clicar vai para o local referido da notificação. Ao clicar vai para o local referido da notificação. `
                notificacoes.push(element)
            }

            return notificacoes
        }

        return {
            notificacoes,
            inicializarComponente,
            SidebarStore
        }
    }
})
</script>

<style scoped>
.notificacoes-espacamento-rodape {
    padding-bottom: 150px;
}

.notificacoes-conteudo {
    font-size: 12px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-weight: bold;
    color: #164e79;
    height: 64px;
    overflow: hidden;
    padding: .5rem .5rem 0 0;

}

.notificacoes-conteudo:hover {
    cursor: pointer;
}

.notificacoes-conteudo-barra-laranja {
    position: relative;
    width: 2px;
    height: 100%;
    background-color: #f58634;
    z-index: 0;
    float: left;
}
</style>